var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "layout" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c("div", { staticClass: "form-field" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "input-field",
                    {
                      attrs: {
                        readonly: "",
                        id: "numero_documento",
                        placeholder: "###-###-#########"
                      },
                      model: {
                        value: _vm.modelValue.numero_documento,
                        callback: function($$v) {
                          _vm.$set(_vm.modelValue, "numero_documento", $$v)
                        },
                        expression: "modelValue.numero_documento"
                      }
                    },
                    [
                      _vm._v(
                        "\n                            Documento de sustento\n                        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.comprobanteSeleccionado,
                          expression: "!comprobanteSeleccionado"
                        }
                      ],
                      staticClass: "btn-info",
                      attrs: { type: "button" },
                      on: { click: _vm.consultarComprobantes }
                    },
                    [_c("i", { staticClass: "fa fa-search" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.comprobanteSeleccionado,
                          expression: "comprobanteSeleccionado"
                        }
                      ],
                      staticClass: "btn-danger",
                      attrs: { type: "button" },
                      on: { click: _vm.quitarComprobante }
                    },
                    [_c("i", { staticClass: "fa fa-ban" })]
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      id: "fechaEmisionSustento",
                      placeholder: "YYYY-MM-DD",
                      readonly: ""
                    },
                    model: {
                      value: _vm.modelValue.fecha_emision_doc,
                      callback: function($$v) {
                        _vm.$set(_vm.modelValue, "fecha_emision_doc", $$v)
                      },
                      expression: "modelValue.fecha_emision_doc"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        Fecha de emisión de documento\n                    "
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      tooltip:
                        _vm.modelValue.numero_aut_documento !== ""
                          ? _vm.modelValue.numero_aut_documento
                          : "Digite...",
                      id: "numero_aut_documento",
                      placeholder: "##########",
                      readonly: ""
                    },
                    model: {
                      value: _vm.modelValue.numero_aut_documento,
                      callback: function($$v) {
                        _vm.$set(_vm.modelValue, "numero_aut_documento", $$v)
                      },
                      expression: "modelValue.numero_aut_documento"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        Número de autorización del documento\n                    "
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c("div", { staticClass: "form-field" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "input-field",
                    {
                      attrs: {
                        id: "identificacionDestinatario",
                        placeholder: "Id destinatario"
                      },
                      model: {
                        value: _vm.modelValue.identificacion_destinatario,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.modelValue,
                            "identificacion_destinatario",
                            $$v
                          )
                        },
                        expression: "modelValue.identificacion_destinatario"
                      }
                    },
                    [
                      _vm._v(
                        "\n                            Identificación del destinatario\n                        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.destinatarioSeleccionado,
                          expression: "!destinatarioSeleccionado"
                        }
                      ],
                      staticClass: "btn-success",
                      attrs: { type: "button" },
                      on: { click: _vm.consultarCliente }
                    },
                    [_c("i", { staticClass: "fa fa-check" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.destinatarioSeleccionado,
                          expression: "destinatarioSeleccionado"
                        }
                      ],
                      staticClass: "btn-danger",
                      attrs: { type: "button" },
                      on: { click: _vm.quitarPersona }
                    },
                    [_c("i", { staticClass: "fa fa-ban" })]
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c("div", { staticClass: "form-field" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "input-field",
                    {
                      attrs: {
                        tooltip:
                          _vm.modelValue.nombre_destinatario !== ""
                            ? _vm.modelValue.nombre_destinatario
                            : "Seleccione...",
                        readonly: "",
                        id: "nombreDestinatario",
                        placeholder: "Nombre o Razón social"
                      },
                      model: {
                        value: _vm.modelValue.nombre_destinatario,
                        callback: function($$v) {
                          _vm.$set(_vm.modelValue, "nombre_destinatario", $$v)
                        },
                        expression: "modelValue.nombre_destinatario"
                      }
                    },
                    [
                      _vm._v(
                        "\n                            Nombre del destinatario\n                        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-info",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$modal.show("listaDestinatarios")
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-search" })]
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      tooltip:
                        _vm.modelValue.direccion_destinatario !== ""
                          ? _vm.modelValue.direccion_destinatario
                          : "Digite...",
                      id: "direccionDestinatario",
                      placeholder: "Dirección o referencia"
                    },
                    model: {
                      value: _vm.modelValue.direccion_destinatario,
                      callback: function($$v) {
                        _vm.$set(_vm.modelValue, "direccion_destinatario", $$v)
                      },
                      expression: "modelValue.direccion_destinatario"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        Dirección del destinatario\n                    "
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      readonly: "",
                      id: "codigoEstablecimiento",
                      placeholder: "###"
                    },
                    model: {
                      value: _vm.modelValue.cod_establecimiento,
                      callback: function($$v) {
                        _vm.$set(_vm.modelValue, "cod_establecimiento", $$v)
                      },
                      expression: "modelValue.cod_establecimiento"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        Código de establecimiento\n                    "
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      tooltip:
                        _vm.modelValue.motivo_traslado !== ""
                          ? _vm.modelValue.motivo_traslado
                          : "Digite...",
                      id: "motivoTraslado",
                      placeholder: "Motivo"
                    },
                    model: {
                      value: _vm.modelValue.motivo_traslado,
                      callback: function($$v) {
                        _vm.$set(_vm.modelValue, "motivo_traslado", $$v)
                      },
                      expression: "modelValue.motivo_traslado"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        Motivo del traslado\n                    "
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "XXXXXXXXXXXXXXXXXXXX",
                        expression: "'XXXXXXXXXXXXXXXXXXXX'"
                      }
                    ],
                    attrs: { id: "documentoAduanero", placeholder: "####" },
                    model: {
                      value: _vm.modelValue.documento_aduanero,
                      callback: function($$v) {
                        _vm.$set(_vm.modelValue, "documento_aduanero", $$v)
                      },
                      expression: "modelValue.documento_aduanero"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        Documento aduanero\n                    "
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      tooltip:
                        _vm.modelValue.ruta !== ""
                          ? _vm.modelValue.ruta
                          : "Digite...",
                      id: "ruta",
                      placeholder: "Ruta del destino"
                    },
                    model: {
                      value: _vm.modelValue.ruta,
                      callback: function($$v) {
                        _vm.$set(_vm.modelValue, "ruta", $$v)
                      },
                      expression: "modelValue.ruta"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        Ruta\n                    "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-xs-12" },
            [
              _c("h5", [_vm._v("Ítems")]),
              _vm._v(" "),
              _c("tabla-item-guia-remision", {
                attrs: { idComprobante: _vm.modelValue.id_comprobante },
                model: {
                  value: _vm.modelValue.detalles,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "detalles", $$v)
                  },
                  expression: "modelValue.detalles"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-buttons" }, [
          _c(
            "button",
            {
              staticClass: "btn-danger btn--text",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("cancelar")
                }
              }
            },
            [
              _c("i", { staticClass: "fa fa-ban" }),
              _c("span", [_vm._v("Cancelar")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-success",
              attrs: { type: "button" },
              on: { click: _vm.aceptar }
            },
            [
              _c("i", { staticClass: "fa fa-check" }),
              _c("span", [_vm._v("Aceptar")])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "listaComprobantesVenta",
            width: "70%",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("lista-comprobantes", {
            on: { selected: _vm.selectedComprobante }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "listaDestinatarios",
            width: "70%",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("lista-personas", {
            attrs: { filterStatus: false, createButton: false },
            on: { selected: _vm.selectedPersona }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            scrollable: "",
            width: "70%",
            height: "auto",
            name: "destinatario"
          }
        },
        [
          _c("persona", {
            attrs: {
              numeroIdentificacion: _vm.modelValue.identificacion_destinatario,
              searchButton: false
            },
            on: { saved: _vm.savedPersona }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "card__title" }, [
        _c("h3", [_vm._v("Detalle de guía de remisión")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a7bc770", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a7bc770","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/DetalleGuiaRemision.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1a7bc770","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/DetalleGuiaRemision.vue
// module chunks = 0